import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
const SACRED_SYMBOLS = [
// Cho Ku Rei
'M12 2v16c0 2 2 3 4 3s4-1 4-3-2-3-4-3-4 1-4 3c0 1 .5 2 1.5 2.5M12 6c-3 0-5 2-5 4s2 4 5 4 5-2 5-4-2-4-5-4z',
// Sei He Ki
'M7 4c0 4 2 6 5 6s5-2 5-6M12 10v10M9 14h6M5 8h14',
// Hon Sha Ze Sho Nen
'M12 3v18M8 7h8M7 11h10M9 15h6M10 19h4',
// Dai Ko Myo
'M12 2L4 10h16L12 2zM12 10v12M8 14h8M6 18h12',
// Raku (grounding)
'M12 2Q8 8 12 14Q16 8 12 2M12 14v8',
// Spiral energy
'M12 4a8 8 0 0 1 0 16a6 6 0 0 0 0-12a4 4 0 0 1 0 8a2 2 0 0 0 0-4'];
const COLORS = ['#a78bfa', '#c084fc', '#d8b4fe', '#D4AF37', '#F9E29C', '#e9d5ff'];
export function FloatingReikiSymbols() {
  const symbols = useMemo(() => {
    return Array.from({
      length: 18
    }).map((_, i) => {
      const isEdge = Math.random() > 0.4;
      const leftPos = isEdge ? Math.random() > 0.5 ? Math.random() * 15 : 85 + Math.random() * 15 : Math.random() * 100;
      return {
        id: `floating-reiki-${i}`,
        path: SACRED_SYMBOLS[i % SACRED_SYMBOLS.length],
        left: `${leftPos}%`,
        top: `${Math.random() * 100}%`,
        size: Math.random() * 70 + 35,
        color: COLORS[i % COLORS.length],
        duration: Math.random() * 30 + 25,
        delay: Math.random() * 15,
        driftX: (Math.random() - 0.5) * 40,
        driftY: (Math.random() - 0.5) * 60,
        rotateRange: (Math.random() - 0.5) * 20
      };
    });
  }, []);
  return <div className="absolute inset-0 pointer-events-none overflow-hidden z-[3]" data-id="element-164">
      {symbols.map(s => <motion.svg key={s.id} viewBox="0 0 24 24" fill="none" stroke={s.color} strokeWidth="0.4" strokeLinecap="round" strokeLinejoin="round" className="absolute" style={{
      left: s.left,
      top: s.top,
      width: s.size,
      height: s.size
    }} initial={{
      opacity: 0,
      rotate: 0
    }} animate={{
      opacity: [0, 0.05, 0.05, 0],
      x: [0, s.driftX, 0],
      y: [0, s.driftY, 0],
      rotate: [0, s.rotateRange, -s.rotateRange, 0]
    }} transition={{
      duration: s.duration,
      repeat: Infinity,
      delay: s.delay,
      ease: 'easeInOut',
      times: [0, 0.3, 0.7, 1]
    }} data-id="element-165">
          <path d={s.path} data-id="element-166" />
        </motion.svg>)}
    </div>;
}